var site = site || {};
site.bgPosition = {
	init:function(bgPos) {
		$('<div class="bgPositionSlider" />').insertAfter($('.bgPosition'));
		$('.bgPositionSlider').slider({
			orientation: 'horizontal',
			range: 'min',
			min: 0,
			max: 100,
			value: bgPos,
			slide: function( event, ui ) {
				$('#backgroundPosition').val(ui.value);
				$('.bgPosition').css('background-position-x', ui.value + '%');
			}
		});
	}
};
